import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './ProductPrice.less';
import convertCurrencyFormat from '../../../../util/currencyFormatter';
/**
 * Render product description
 * @param className
 * @param description
 * @returns {*}
 * @constructor
 */
const ProductPrice = ({ className, price, referencePrice, upperBoundPrice }) => {
  const containerClassName = cx('product-price-container', className);
  const productPrice = `${price}${upperBoundPrice ? ` - ${upperBoundPrice}` : ''}`;
  if (referencePrice) {
    const { type } = referencePrice;
    const MSRPToolTip = `"MSRP" refers to the manufacturer’s suggested
                       retail price, which may not be the prevailing
                       market price or the regular retail price.`;
    const referenceProductPrice = referencePrice.amount || referencePrice.min_price / 100;
    const lowerBoundReferencePrice = convertCurrencyFormat(referenceProductPrice, 'USD', 0, 2);
    const hasReferencePriceRnge = referencePrice.min_price < referencePrice.max_price;
    const upperBoundReferencePrice =
      hasReferencePriceRnge &&
      ` - ${convertCurrencyFormat(referencePrice.max_price / 100, 'USD', 0, 2)}`;
    if (type === 'MSRP') {
      return (
        <div className={containerClassName}>
          <p className="product-price_reference product-price_reference-msrp">
            MSRP
            <span className="with-tooltip" data-tooltip={MSRPToolTip}>
              <i className="zolaicon zolaicon-info" />
            </span>
            {lowerBoundReferencePrice}
            {hasReferencePriceRnge && upperBoundReferencePrice}
          </p>
          <p className={`product-price_list-price ${upperBoundPrice ? 'has-upperboundPrice' : ''}`}>
            Our Price {productPrice}
          </p>
        </div>
      );
    }

    if (type === 'COMPAREATPRICE') {
      return (
        <div className={containerClassName}>
          <p className="product-price_reference product-price_reference-sale">
            Was{' '}
            <span className="product-price__span--strike-through">
              {lowerBoundReferencePrice}
              {hasReferencePriceRnge && upperBoundReferencePrice}
            </span>
          </p>
          <p className="product-price_list-price">Sale {productPrice}</p>
        </div>
      );
    }
  }

  return (
    <div className={containerClassName}>
      <p className="product-price_list-price">{productPrice}</p>
    </div>
  );
};

ProductPrice.propTypes = {
  className: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  upperBoundPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  referencePrice: PropTypes.shape({
    amount: PropTypes.number,
    type: PropTypes.string,
  }),
};

export default ProductPrice;
